var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        _vm._b(
          { ref: "formRef", attrs: { model: _vm.form, rules: _vm.rules } },
          "el-form",
          _vm.formConfig,
          false
        ),
        [
          _c(
            "el-form-item",
            { attrs: { label: "排序：" } },
            [
              _c("el-input-number", {
                attrs: {
                  step: 1,
                  min: 0,
                  placeholder: "请输入排序",
                  "controls-position": "right",
                },
                model: {
                  value: _vm.form.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sort", $$v)
                  },
                  expression: "form.sort",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "同步分销授权：", prop: "customerId" } },
            [
              _vm.isIntegralMode
                ? _c(
                    "div",
                    {
                      staticClass: "form-tip",
                      staticStyle: { "margin-bottom": "8px" },
                    },
                    [
                      _c("i", { staticClass: "el-icon-info" }),
                      _vm._v(
                        " 所选优惠券为积分兑换券，默认同步授权全部分销商，且不支持修改\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  ref: "customersListTableRef",
                  attrs: { data: _vm.comData.customersList },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      align: "center",
                      selectable: _vm.rowSelectable,
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "分销商名称" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }